
import { cn } from "@/lib/utils";
import { SidebarLinkProps } from "./types";
import { Link } from "react-router-dom";

export const SidebarLink = ({ item, isActive, isDisabled, onClick, className, isDropdownItem }: SidebarLinkProps) => {
  return (
    <Link
      to={item.href}
      onClick={onClick}
      className={cn(
        "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-all w-full",
        isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
        isDisabled && "opacity-50 cursor-not-allowed",
        isDropdownItem && "text-sm",
        className
      )}
    >
      <item.icon className="h-4 w-4" />
      <span>{item.name}</span>
      {item.href === "#" && (
        <svg
          className="ml-auto h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      )}
    </Link>
  );
};
